export default "__VITE_ASSET__pil6iyzM__"